import classNames from 'classnames';
import React from 'react';
import './index.scss';

interface EfFooterTcItemProps {
    /**
     * 是否是标题样式
     */
    isHeader?: boolean;
    /**
     * 标题
     */
    title?: React.ReactNode;
    /**
     * 样式名
     */
    className?: string;
}
interface EfFooterTcProps {
    /**
     * 列表
     */
    list: EfFooterTcItemProps[];
    /**
     * 样式名
     */
    className?: string;
}

/**
 * 维护:谢保林
 *
 * 底部提示语
 */
const EfFooterTc: React.FC<EfFooterTcProps> = ({ list, className }) => {
    const prefixCls = `ef-footer-tc`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });

    return (
        <div className={classes}>
            <div className={`${prefixCls}-in`}>
                {list?.map((item: any, index: number) => {
                    return (
                        <div key={index} className={`${prefixCls}-item${item.isHeader ? ` ${prefixCls}-item-h` : ''}`}>
                            {item.title}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default EfFooterTc;
